import { v4 as uuidv4 } from "uuid";

import IBaseZone, { IBaseZoneApi, mapApiPointsToPoints, mapPointsToApi } from "./base-zone";
import ZonePointType from "../../../enums/robot/rooms/zone-point-type";
import FrontLightsMode from "../cleaning-configurations/front-lights-mode";
import RedZone from "./red-zone";
import CleaningZone from "./cleaning-zone";
import { mapMapRulesConfigurationApiToMapRulesConfiguration, mapMapRulesConfigurationToApi, MapRulesConfiguration, MapRulesConfigurationApi } from "../cleaning-configurations/map-rules-configuration";
import { MinObstacleHeightOption } from "../cleaning-configurations/global-cleaning-configuration";

interface RuleZone extends IBaseZone {
    name: string | null;
    mapRulesConfiguration: MapRulesConfiguration;
}

export interface RuleZoneApi extends IBaseZoneApi {
    name: string | null;
    mapRulesConfiguration: MapRulesConfigurationApi;
}

export const mapRuleZoneApiToRuleZone = (apiData: RuleZoneApi) =>
({
    ...apiData,
    points: mapApiPointsToPoints(apiData.points, ZonePointType.RuleZoneCorner),
    mapRulesConfiguration: mapMapRulesConfigurationApiToMapRulesConfiguration(apiData.mapRulesConfiguration),
} as RuleZone);

export const mapRuleZoneToApi = (ruleZone: RuleZone) =>
({
    ...ruleZone,
    points: mapPointsToApi(ruleZone.points.map((p) => p.point)),
    mapRulesConfiguration: mapMapRulesConfigurationToApi(ruleZone.mapRulesConfiguration),
} as RuleZoneApi);

export const mapPartialRuleZoneToApi = (ruleZone: Partial<RuleZone>) =>
({
    ...ruleZone,
    points: ruleZone.points !== undefined ? mapPointsToApi(ruleZone.points.map((p) => p.point)) : undefined,
    mapRulesConfiguration:
          ruleZone.mapRulesConfiguration !== undefined
            ? mapMapRulesConfigurationToApi(ruleZone.mapRulesConfiguration)
            : undefined,
} as Partial<RuleZoneApi>);

export const newRuleZone = (name: string, roomId: string): RuleZone => {
  return {
    id: uuidv4(),
    room: roomId,
    name: name,
    points: [],
    mapRulesConfiguration: {
      beeper: null,
      frontLightsMode: null,
      warningLight: null,
      drivingSpeed: null,
      minObstacleHeightM: null,
    } as MapRulesConfiguration,
  };
};

export const copyRuleZone = (zone: RuleZone) => {
  return {
    ...zone,
    points: [...zone.points.map((p) => ({ orderIndex: p.orderIndex, point: { ...p.point } }))],
  };
};

export const isRuleZone = (zone: CleaningZone | RedZone | RuleZone): zone is RuleZone => {
  return "mapRulesConfiguration" in zone;
};

export default RuleZone;